export const useCasesData = [
  {
    slug: 'healthcare',
    industrySector: 'Healthcare & Clinics',
    heroHeadline: 'Patient Data Belongs on Your Servers — Not on a Shared SaaS Cloud',
    painPointLead: 'Multi-clinic networks juggle patient records across spreadsheets, WhatsApp groups, and legacy software that was never designed for compliance. Every workaround is a liability.',
    theProblem: [
      'Patient data scattered across 3-4 disconnected systems with no single source of truth',
      'Appointment reminders sent manually — leading to 15-20% no-show rates',
      'Audit trails either missing or unreliable, creating compliance exposure',
      'Per-user SaaS licensing that gets more expensive every time you hire'
    ],
    architectureSolution: 'We deploy SuiteCRM on private, HIPAA-aligned infrastructure — your cloud or on-prem. Patient records, appointment workflows, and communication logs live in one system with audit trails, role-based access, and encryption at rest. No shared multi-tenant servers. No third-party data access.',
    features: [
      'Audit logging with tamper-proof trails for every patient record change',
      'Automated appointment reminders via WhatsApp and SMS (n8n-powered)',
      'On-premise or private cloud deployment — full data sovereignty',
      'Role-based access: front desk sees schedules, doctors see records, admins see everything',
      'Custom modules for referral tracking, insurance verification, and follow-up care'
    ],
    roiStat: 'Reduced no-show rates by 35% and cut annual CRM costs by ₹18L for a 40-clinic network',
    resultDetails: [
      { value: '35%', label: 'Reduction in no-shows', desc: 'Automated reminders via WhatsApp 24hrs and 2hrs before appointments' },
      { value: '₹18L/yr', label: 'Saved in licensing', desc: 'Migrated from per-user SaaS CRM to self-hosted SuiteCRM' },
      { value: '100%', label: 'Audit compliance', desc: 'Every record change logged with user, timestamp, and before/after values' }
    ]
  },
  {
    slug: 'logistics',
    industrySector: 'Logistics & Supply Chain',
    heroHeadline: 'Your CRM Shouldn\'t Throttle When Your Business Peaks',
    painPointLead: 'Freight brokers and 3PL operators hit API rate limits on cloud CRMs during peak shipping hours — exactly when they need the system most. Deals stall. Tracking breaks. Clients call asking for updates you can\'t give.',
    theProblem: [
      'Cloud CRM API limits throttle webhook processing during peak hours',
      'Carrier and shipment data trapped in siloed systems with no real-time sync',
      'Custom dashboards for tracking BOL status are either impossible or cost extra',
      'Scaling to 10,000+ API events/hour requires expensive enterprise tier upgrades'
    ],
    architectureSolution: 'We engineer SuiteCRM environments with dedicated Redis caching and self-hosted n8n automation — no API rate limits, no per-webhook fees. Bill of Lading events, carrier updates, and shipment status changes flow through continuously at any volume.',
    features: [
      'Unlimited API and webhook processing — no rate limits at any volume',
      'Custom carrier portal with real-time shipment dashboards',
      'Real-time inventory and order sync with ERPs and warehouse systems',
      'Automated carrier assignment based on route, cost, and availability rules',
      'WhatsApp notifications to clients with live tracking updates'
    ],
    roiStat: 'Scaled a freight brokerage from 5,000 to 50,000 API events/hour with zero throttling',
    resultDetails: [
      { value: '10x', label: 'API throughput increase', desc: 'From 5,000 to 50,000 events/hour with no throttling or downtime' },
      { value: '₹0', label: 'Per-webhook fees', desc: 'Self-hosted n8n replaces SaaS automation with no per-task pricing' },
      { value: '4 hrs', label: 'Saved per day in manual tracking', desc: 'Automated shipment status updates replaced manual carrier check-ins' }
    ]
  },
  {
    slug: 'financial-services',
    industrySector: 'Financial Services & Wealth Management',
    heroHeadline: 'Your Client Financial Data Is Too Sensitive for a Multi-Tenant Cloud',
    painPointLead: 'Wealth managers and financial advisors store client portfolios, transaction histories, and compliance-sensitive data on shared cloud CRMs — often without realising the third-party access implications.',
    theProblem: [
      'Client financial data stored on multi-tenant SaaS servers with shared infrastructure',
      'Compliance audits require data residency proof that SaaS vendors can\'t always provide',
      'Relationship managers track deals in spreadsheets because the CRM doesn\'t fit their workflow',
      'Onboarding new advisors takes weeks due to complex permission hierarchies'
    ],
    architectureSolution: 'We implement SuiteCRM on encrypted, dedicated infrastructure — bare-metal or private cloud. Client portfolios, deal pipelines, and compliance records are fully isolated with end-to-end encryption, field-level permissions, and audit trails that satisfy regulatory scrutiny.',
    features: [
      'End-to-end database encryption with key management you control',
      'Regulatory compliance architecture (adaptable to SEBI, RBI, or international standards)',
      'Private MCP integration for AI-assisted portfolio analysis without data leaving your servers',
      'Multi-level permission hierarchies: advisors, compliance officers, and management each see only what they should',
      'Automated client onboarding workflows with document collection and KYC triggers'
    ],
    roiStat: 'Migrated a wealth management firm off SaaS CRM in 60 days — zero data exposure during transition',
    resultDetails: [
      { value: '60 days', label: 'Full migration completed', desc: 'From SaaS CRM to self-hosted SuiteCRM with zero data exposure' },
      { value: '100%', label: 'Data residency compliance', desc: 'All client data on dedicated infrastructure with auditable encryption' },
      { value: '3x faster', label: 'Advisor onboarding', desc: 'Automated workflows replaced manual onboarding checklists' }
    ]
  }
];
